// 根据电脑来判断语言
module.exports = {
    message: {
      hello: 'good good study, day day up6666666!'
    }
}
